import React, { createContext, useContext, useState, useCallback } from 'react';
import ModalGirosGanhos from '../Components/ModalGirosGanhos';

export const GirosGanhosContext = createContext();

export const useGirosGanhos = () => useContext(GirosGanhosContext);

export const GirosGanhosProvider = ({ children }) => {
  const [giros, setGiros] = useState(0);

  // Abre o modal de giros ganhos. Aceita qualquer valor; só exibe se > 0.
  const mostrarGirosGanhos = useCallback((quantidade) => {
    const qtd = Number(quantidade) || 0;
    if (qtd > 0) {
      setGiros(qtd);
    }
  }, []);

  const fechar = useCallback(() => setGiros(0), []);

  return (
    <GirosGanhosContext.Provider value={{ mostrarGirosGanhos }}>
      {children}
      <ModalGirosGanhos giros={giros} onClose={fechar} />
    </GirosGanhosContext.Provider>
  );
};
